import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { FreelancersPage } from "@/features/freelancers/FreelancersPage";

const search = z.object({
  compliance: z.enum(["all", "complete", "expiring", "missing"]).optional(),
  view: z.enum(["table", "cards"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/freelancers/")({
  validateSearch: search,
  component: () => <FreelancersPage search={Route.useSearch()} />,
});
